import Lookup from 'src/componentes/select2';
import ParteInteressadaEdit from 'src/paginas/parte-interessada/edit';

const ParteInteressadaLookup = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/ParteInteressadaLookup"
      editComponent={ParteInteressadaEdit}
      {...props}
    />
  );
};

export default ParteInteressadaLookup;
